import _ from 'lodash'
import { getClusterMarkerStyle } from 'map-style-utils'
import { Layer, LayerProps } from 'ms-map-gl'
import { useMemo } from 'react'

import { ClusterZoomPlugin } from '~map-preview/App/Map/Plugins/ClusterZoomPlugin'
import { FeatureIdentifyPlugin } from '~map-preview/App/Map/Plugins/FeatureIdentifyPlugin'
import { HoverPlugin } from '~map-preview/App/Map/Plugins/HoverPlugin'
import { useLayerFilter } from '~map-preview/hooks/useLayerFilter'
import { getLayerId } from '~map-preview/utils/getLayerId'

export const ClusterLayer = () => {
  const { symbol, label, cluster } = useMemo(() => getClusterMarkerStyle(), [])

  const filter = useLayerFilter()

  return (
    <>
      <Layer {...(cluster as LayerProps)} />
      <Layer {...(label as LayerProps)} />
      <Layer
        {...(symbol as LayerProps)}
        {...(filter as object)}
      />

      <ClusterZoomPlugin
        source='mapstack-points-cluster'
        layer={cluster.id}
      />

      <HoverPlugin
        source='mapstack-points-cluster'
        layer={_.get(cluster, 'id', '')}
      />

      <FeatureIdentifyPlugin layer={getLayerId(symbol)} />
    </>
  )
}
